<template>
    <div id="vehiclemodel_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Fuel Reading List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <router-link v-if="canAddMod && endShift==false" class="btn btn-primary" v-bind:to="{name: 'FuelReadingCreate'}" > <i class="fp-add"> </i> Add</router-link>
                        <router-link title="Edit Fuel Reading" v-if="endShift == true && reading_identifier !='' " class="btn btn-secondary" v-bind:to="{name: 'FuelReadingEdit',params:{id:reading_identifier},query:{flag:'end_shift'}}"> End Shift</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-detail">
                        <data-table-filter-config :moduleName="'fuelReadinglist'" ref="filterFuelReadinglList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'fuelReadinglist'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listFuelReadingTable"
                                    mode="remote"
                                    title="FuelPrice"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: fuelmode_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Fuel Reading" v-if="canUpdateMod == true" class="fp-edit" v-bind:to="{name: 'FuelReadingEdit',params:{id:props.row.reading_identifier}}"></router-link>
                                                <router-link title="View Fuel Reading" class="ml-3 fp-view" v-bind:to="{name: 'FuelReadingView',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="fuelmode_value" id="deleteVehicleModelBtn" v-on:click.prevent="fuelreadingDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "VehicleModelList",
        metaInfo() {
            return {title: "Fuel Reading List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Reading Date',
                    field: 'reading_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Pump#',
                    field: 'tank_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Pump No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Item',
                    field: 'item',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Item", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Total Pump Reading',
                    field: 'total_tank_reading',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Total Pump Rading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Total Meter Reading',
                    field: 'total_meter_reading',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Total Meter Rading", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            fuelmode_value: false,
            loading:false,
            canAddMod:false,
            canUpdateMod:false,
            action:'list',
            endShift:false,
            reading_identifier:'',
            userRole:'',
            pageKey:"_fuel_reading_list_",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_fuel_reading') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_fuel_reading') {
                            self.fuelmode_value = true;
                        }
                        if (permissions[i].name == 'add_fuel_reading') {
                            self.canAddMod = true;
                            self.canUpdateMod = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            self.getPermissions();

            var userObj = JSON.parse(localStorage.getItem("user_obj"));

            if (userObj != null) {
                if (userObj.roles.length > 0) {
                    self.userRole = userObj.roles[0].name;
                }

            }
            for(var i = 0; i < userObj.roles.length; i++){
                if (userObj.roles[i].name == 'fueler') {
                    self.checkFuelReading();
                }

            }
            // if(self.userRole == 'fueler') {
                // self.checkFuelReading();
            // }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listFuelReadingTable.unselectAllInternal();
            },
            checkFuelReading(){
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-reading/check",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if(data.status=='success'){

                           self.endShift=true;
                           self.reading_identifier=data.content.reading_identifier;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'fuel-product-load-by-location')
                    }
                });
            },
            selectionChanged(param) {
                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var data = this.$refs['listFuelReadingTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listFuelReadingTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-reading/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if (self.action == 'delete'){
                                self.action = 'list';
                                self.$refs.filterFuelReadinglList.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                            self.filteredFlag = false;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'load-asset-model-list')
                    }
                });
            },
            fuelreadingDelete() {
                var data = this.$refs['listFuelReadingTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listFuelReadingTable'].selectedRows[i].id)
                }
                self.$swal({
                    title: 'Are you sure that you want to delete this Reading?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = 'delete';
                      self.loadList();

                    } else {
                      console.log("no");
                    }
                });

                // if (confirm('Are you sure that you want to delete this Reading? ')) {
                //     self.action = 'delete';
                //     self.loadList();

                // }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/FuelReadingList.vue